import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { APP_CONFIG, AppConfig } from './app.config';
import { provideLottieOptions } from 'ngx-lottie';

fetch('/assets/config.json')
  .then((response) => response.json())
  .then((config: AppConfig) => {
    addScripts(config.scripts);

    bootstrapApplication(AppComponent, {
      providers: [
        { provide: APP_CONFIG, useValue: config },
        provideLottieOptions({
          player: () => import('lottie-web'),
        }),
        ...appConfig.providers,
      ],
    }).catch((err) => console.error(err));
  });

function addScripts(scripts: string[] | undefined) {
  if (!scripts) return;
  scripts.forEach((src) => {
    let s = document.createElement('script');
    s.setAttribute('src', src);
    document.head.appendChild(s);
  });
}
